/**
 * 第三方页面模拟API，Fw.js
 *
 * 手机银行APP将进行页面URL的域名检查
 * 调用方需在我行登记生产环境的URL；https://www.xxx.com:port/
 * 只有合法的域名才能调用文档中的API
 */
function ready(callback) {
  // 如果 jsbridge 已经注入则直接调用
  if (window.AlipayJSBridge) {
    callback && callback()
  } else {
    // 如果没有注入则监听注入的事件
    document.addEventListener('AlipayJSBridgeReady', callback, false)
  }
}
window.Fw = {
  /**
   * 属性复制（同jQuery的$.extend）
   * @param {} object
   * @param {} config
   * @param {} defaults
   */
  apply: function (object, config, defaults) {
    if (defaults) {
      Fw.apply(object, defaults)
    }
    if (object && config && Fw.isObject(config)) {
      for (var property in config) {
        object[property] = config[property]
      }
    }
    return object
  },
  /**
   * 是否是对象
   * @param {} v
   */
  isObject: function (v) {
    return (
      !!v &&
      Fw.toString(v) === '[object Object]' &&
      !Fw.isNumber(v.length) &&
      !Fw.isFunction(v.splice) &&
      (!Fw.isFunction(v.propertyIsEnumerable) ||
        !v.propertyIsEnumerable('splice'))
    )
  },
  /**
   * 是否是函数
   * @param {} v
   */
  isFunction: function (v) {
    return Fw.toString(v) === '[object Function]'
  },
  /**
   * 是否是数值型
   * @param {} v
   */
  isNumber: function (v) {
    return typeof v === 'number' && isFinite(v)
  },
  /**
   * 是否是字符型
   * @param {} v
   */
  isString: function (v) {
    return typeof v === 'string'
  },
  /**
   * 转换为字符
   * @param {Object} v
   */
  toString: function (v) {
    return Object.prototype.toString.apply(v)
  },
  /**
   * 是否是数组
   * @param {} v
   */
  isArray: function (v) {
    return Fw.toString(v) === '[object Array]'
  },
  /**
   * 是否为空
   * @param {} v
   * @param {} allowBlank
   */
  isEmpty: function (v, allowBlank) {
    if (Fw.isObject(v)) {
      var name
      for (name in v) {
        return false
      }
      return true
    }
    if (Fw.isArray(v)) {
      return !v.length
    }
    return (
      v === null ||
      v === undefined ||
      String(v).toUpperCase() === 'NULL' ||
      (!allowBlank ? v === '' : false)
    )
  },
  _registerAlipayJSB: async function (plugName, cfg = {}, flag = true) {
    !plugName.startsWith('ares') && flag && (plugName = `ares_${plugName}`)
    //
    ready(() => {
      // 调用阿里jsb
      AlipayJSBridge.call(plugName, cfg, function ({ data }) {
        console.log('AlipayJSBridge_' + plugName, data)
        // 如果返回的空的data走失败
        if (Fw.isEmpty(data) || Fw.isEmpty(data._callbackName)) {
          data = Fw.apply(data || {}, {
            _callbackName: 'fail',
          })
        }
        console.log('fd_getUserInfo', data)
        // 获取客户端回调方法名(suceess、fail)
        let _callbackName = data._callbackName
        // 删除回调名，防止传给前端
        delete data._callbackName
        // 删除errMsg
        delete data.errMsg
        // 回调前端方法(sucess、fail)
        if (Fw.isString(cfg[_callbackName])) {
          // 字符串函数
          eval(cfg[_callbackName])(data)
        } else {
          cfg[_callbackName] && cfg[_callbackName](data)
        }
      })
    })
  },
  getUser(openId) {
    return new Promise((resolve, reject) => {
      this._registerAlipayJSB(
        'fd_getUserInfo',
        {
          openId: openId,
          success: (res) => {
            resolve(res)
          },
          fail: (err) => {
            console.log('err', err)
            if (err.code == '005') {
              Fw.delUserInfo().then(async () => {
                await Fw.setStorageSync('OVERTIME_SOO', 'true')
                await Fw.setStorageSync('_PassiveLogin', {
                  goBack: '0',
                })
                // 跳到登录
                this._registerAlipayJSB('login', {})
              })
            }
          },
        },
        false,
      )
    })
  },
  /**
   * 清除用户数据
   */
  delUserInfo() {
    return new Promise((resolve, reject) => {
      this._registerAlipayJSB('userInfo', {
        type: 'set',
        login: 'N',
        info: '',
        success: (res) => {
          resolve(res.userInfo)
        },
      })
    })
  },
  /**
   * 获取登录状态
   */
  getLoginStatus() {
    return new Promise((resolve, reject) => {
      this.getUser('checkSession').then((res) => {
        let loginStatus = false
        if (res && res.data && !this.isEmpty(res.data.ENCRYPT_DIVISOR)) {
          loginStatus = true
        }
        resolve({
          loginStatus,
          userInfo: res,
        })
      })
    })
  },
  /**
   * 获取页面栈数量
   */
  getCurrentPages() {
    return new Promise((resolve, reject) => {
      this._registerAlipayJSB('getCurrentPages', {
        success: (res) => {
          // 成功
          resolve(Number(res.number))
        },
        fail: (err) => {
          // 失败
          resolve(err)
        },
      })
    })
  },
  /**
   * Fw.setStorage
   * 用法: await Fw.setStorage('key', 'data');
   * @param {*} key
   * @param {*} data
   * @param {*} lasted
   */
  setStorageSync(key, data, lasted = false) {
    return new Promise((resolve, reject) => {
      this.setStorage({
        key: key,
        lasted: lasted,
        data: data,
        success: (res) => {
          // 成功
          resolve(res)
        },
        fail: (err) => {
          // 失败
          resolve(err)
        },
      })
    })
  },
  /**
   * 将数据存储在本地缓存中指定的 key 中
   * @param {*} cfg
   */
  setStorage: function (cfg) {
    this._registerAlipayJSB('setStorage', cfg)
  },
  /**
   *
   * 页面跳转，被动登录
   * url 跳转页面的url
   * loginFlag 是否需要登录
   */
  async route(url, loginFlag = false) {
    if (loginFlag) {
      // return this.passiveLogin({
      // 	pageNum: number,
      // 	url: {
      // 		url,
      // 		// 被动登录后需要重定向关闭登录页面
      // 		redirect: '1'
      // 	},
      // 	// 嵌入到客户端页面需要添加此参数
      // 	type: 'nest'
      // 	// 备注：三方跳转不设置setLoginFlag
      // }, 'route')
      await Fw.setStorageSync('_PassiveLogin', {
        goBack: '1',
        url: {
          url,
          // 被动登录后需要重定向关闭登录页面
          redirect: '1',
        },
        // 嵌入到客户端页面需要添加此参数
        type: 'nest',
        // 备注：三方跳转不设置setLoginFlag
      })
      this._registerAlipayJSB('navigateToOnline', {
        url,
        // 是否需要登录
        needLogin: '1',
        // 嵌入到客户端页面需要添加此参数,1嵌入式，0非嵌入式
        nest: '1',
      })
    } else {
      this._registerAlipayJSB('navigateToOnline', {
        url,
        needLogin: '0',
        nest: '1',
      })
    }
  },
  /**
   * 被动登录
   */
  async login() {
    const params = {
      goBack: '1',
    }
    return this.passiveLogin(params)
  },
  // 被动登录公共逻辑处理
  async passiveLogin(params, flag) {
    await Fw.setStorageSync('_PassiveLogin', params)
    const loginParams = await this.getLoginStatus()
    const { loginStatus, userInfo } = loginParams
    return new Promise((resolve, reject) => {
      if (!loginStatus) {
        let psm = {
          success: (res) => {
            resolve(userInfo)
          },
        }
        params.type && (psm.type = params.type)
        this._registerAlipayJSB('login', psm)
      } else {
        if (flag == 'route') {
          this._registerAlipayJSB('navigateToOnline', params.url)
          resolve(userInfo)
        } else {
          resolve(userInfo)
        }
      }
    })
  },
  /**
   * 获取路由跳转参数
   */
  getParams() {
    return new Promise((resolve, reject) => {
      this._registerAlipayJSB('getThirdPageParams', {
        success: (res) => {
          resolve(res)
        },
      })
    })
  },
  /**
   * 客户端
   * @returns
   */
  publicParam: function () {
    return new Promise((resolve, reject) => {
      this._registerAlipayJSB('publicParam', {
        success: (res) => {
          resolve(res)
        },
      })
    })
  },
  /**
   * 心跳维持
   */
  async heartKeep() {
    // 调用mpaas通讯
    // 调用阿里jsb
    let options = {
      method: 'POST', // 默认请求 POST
      dataType: 'json', // 请求类型json
      responseType: 'text', // 响应的数据类型
      contentType: 'application/json', // 请求类型 json
    }
    options.url = 'common/sysdateQry'
    let publicParam = await this.publicParam()
    //
    const head = {
      ...publicParam,
    }
    const params = [
      {
        _requestBody: {
          head,
          body: {},
        },
      },
    ]

    ready(() => {
      AlipayJSBridge.call(
        'rpc',
        {
          /** RPC  服务名称 */
          operationType: options.url || options.service,
          /** RPC  请求的参数。 */
          requestData: params || {},
          /** 网关地址，可以在支付宝中请求网商银行或者其他 app 的网关。 */
          // mpaasGateWay,
          /** 是否使用 request gzip 压缩。 */
          compress: true,
          // 超时，单位s
          timeout: 30000,
        },
        (result) => {},
      )
    })
  },

  /**
   * 获取埋点公共报文
   */
  getBuriedPointParams() {
    return new Promise((resolve, reject) => {
      this._registerAlipayJSB('getBuriedPointParams', {
        success: (res) => {
          resolve(res)
        },
      })
    })
  },
  /**
   * 埋点
   */
  async buriedPoint(params, extParams) {
    // 添加默认埋点参数
    let sendParams = {
      // 法人编号
      bankCd: '',
      // 应用渠道
      chnlCd: '',
      // 应用模板编号
      appTempId: '',
      // 页面来源
      pageFrom: '',
      // 页面编号
      pageNo: '',
      // 运营位编号
      oprLctnId: '',
      // evtCd
      evtCd: '',
      // 机构码
      branch: '',
      // 交易金额
      tranAmt: '',
      // 产品ID
      prodId: '',
      // 活动ID
      actId: '',
      // 信息类型
      infoType: '',
      // 信息编号
      infoId: '',
      // 用户号
      usrId: '',
      // 手机号
      mobile: '',
      // APP唤起方式
      appCallFrom: '',
      // 页面停留时长
      pageDuration: '',
      // 运营位曝光时长
      boothDuration: '',
      // 登录凭证ID
      loginId: '',
    }
    const pointByClient = (await this.getBuriedPointParams()) || {}
    let {
      bankCd, //法人编号
    } = pointByClient //页面来源
    let type = params.type
    // 业务类型，mpaas平台需要
    let bizType = '',
      // 埋点唯一标识，mpaas平台需要
      seedId = ''
    let buriedParams = {}
    if (type == 'route') {
      bizType = params.AppNo
      seedId = params.PageNo
    } else if (type == 'event') {
      bizType = params.bizCode
      // 运营位编号
      buriedParams.oprLctnId = `B${bankCd}_${params.boothCode}`
      // 事件编号
      seedId = buriedParams.evtCd = `E${bankCd}_${params.boothEventCode}`
    }
    // 应用模板
    buriedParams.appTempId = params.AppThemeNo
    // 页面编号
    buriedParams.pageNo = params.PageNo
    // 应用渠道
    buriedParams.chnlCd = params.AppNo
    //
    Object.assign(sendParams, {
      ...buriedParams,
      ...extParams,
    })
    AlipayJSBridge.call('remoteLog', {
      bizType, // 业务类型
      logLevel: 1, // 1 - high, 2 - medium, 3 - low
      actionId: 'event', // 埋点类型，固定为"event"
      seedId, // 埋点唯一标识
      param1: '',
      param2: '',
      param3: '',
      param4: sendParams,
    })
  },
  /**
   * 页面跳转采集
   */
  routeCollect(params = {}) {
    params.type = 'route'
    this.buriedPoint(params)
  },
  /**
   * 页面事件采集
   */
  eventCollect(params = {}, extParams = {}) {
    params.type = 'event'
    this.buriedPoint(params, extParams)
  },
  /**
   * 分享
   * @param {*} params
   * @returns
   */
  share(params) {
    return new Promise((resolve, reject) => {
      this._registerAlipayJSB('share', {
        ...params,
        success: (res) => {
          resolve(res)
        },
      })
    })
  },
  /**
   * 调用原生定位功能
   * @returns
   */
  getLocation() {
    return new Promise((resolve, reject) => {
      this._registerAlipayJSB('getLocation', {
        success: (res) => {
          resolve(res.locationInfo)
        },
        fail: (err) => {
          reject(err)
        },
      })
    })
  },
  // 离线包跳转
  navigateTo(cfg) {
    //
    this._registerAlipayJSB('navigateTo', cfg)
  },
  /**
   * 返回到上一个离线包
   * @param {*} cfg
   */
  navigateBackPackage: function (cfg = {}) {
    // 兼容6.0
    cfg._plugNameHack = 'navigateBackPackage'
    //
    // this.navigateBackMiniProgram(cfg)
    this._registerAlipayJSB('navigateBackPackage', cfg)
  },
  /**
   * 获取客户端版本信息
   * @returns
   * res:{
   * "downloadURL":""下载地址,
   * "guideMemo":""升级信息,
   *
   * "newestVersion":""最新版本,
   * "resultStatus":"201"升级模式
   * }
   */
  getAppVersionInfo() {
    return new Promise((resolve, reject) => {
      this._registerAlipayJSB('getAppVersionInfo', {
        success: (res) => {
          resolve(res)
        },
      })
    })
  },
  // type:'6' 根据页面栈返回 delta必传
  // type:'7' 关闭指定页面
  // type:'1' 关闭除了该页面的其他页面
  pageJump(cfg) {
    let param = {}
    console.warn('ares_pageJump1===>', cfg)
    // 默认返回一个页面
    if (Fw.isEmpty(cfg)) {
      param = {
        type: '6',
        delta: '1',
      }
    }
    // 根据delta返回
    else if (cfg.delta) {
      param = {
        type: '6',
        delta: '' + cfg.delta || 1,
      }
    }
    // 关闭指定页面栈
    else if (cfg.type === '7') {
      param = {
        ...cfg,
      }
    }
    // 关闭全部页面栈
    else if (cfg.type === '1') {
      param = {
        ...cfg,
      }
    }
    // 如果用户指定appId
    else if (cfg.appId) {
      param = {
        type: '2',
        ...cfg,
      }
    } else {
      param = {
        type: '6',
        delta: '1',
      }
    }
    console.log('ares_pageJump2===>', param)
    this._registerAlipayJSB('pageJump', param)
  },
  /**
   * 关闭当前页面，返回上一页面或多级页面
   */
  async navigateBack(params) {
    // const { newestVersion, bundleID } = await Fw.getAppVersionInfo();
    // const vsn = this.getVsn();
    // 等于或高于目标版本vsn
    // if (bundleID === this.bundleID) {
    //   this.pageJump(params);
    //    return;
    //  }
    this._registerAlipayJSB('navigateBack', params)
  },
  chooseImage(cfg) {
    // 默认配置
    cfg = Fw.apply(
      {
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
      },
      cfg,
    )
    return new Promise((resolve, reject) => {
      this._registerAlipayJSB('openMobilePhoto', {
        ...cfg,
        success: (res) => {
          resolve(res)
        },
      })
    })
  },
  /**
   * 设置导航栏标题
   */
  setPageTitle({ title }) {
    this._registerAlipayJSB('initPageTitle', {
      navigationBarTitleText: title,
      title,
    })
  },
  /**
   * H5自定义返回
   */
  goH5Return() {
    this._registerAlipayJSB('goH5Return')
  },
}
